module.exports = __webpack_public_path__ + "img/base_patrimoine_memoire.a1d2bc48.svg";